<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.5333 24C19.8889 24 17.2222 23.3833 14.5333 22.15C11.8444 20.9167 9.36667 19.1667 7.1 16.9C4.83333 14.6333 3.08333 12.1556 1.85 9.46667C0.616667 6.77778 0 4.11111 0 1.46667C0 1.04756 0.139667 0.698334 0.419 0.419C0.698334 0.139667 1.04756 0 1.46667 0H6.37767C6.68878 0 6.95922 0.109223 7.189 0.327667C7.41856 0.546334 7.57033 0.814889 7.64433 1.13333L8.53167 5.481C8.57722 5.81211 8.57033 6.10367 8.511 6.35567C8.45189 6.60744 8.33167 6.82389 8.15033 7.005L4.85567 10.3333C5.389 11.2593 5.97233 12.1316 6.60567 12.95C7.239 13.7684 7.93711 14.5481 8.7 15.289C9.47778 16.0814 10.2963 16.8092 11.1557 17.4723C12.0148 18.1352 12.9184 18.7259 13.8667 19.2443L17.0223 16.0223C17.237 15.7926 17.4954 15.6314 17.7977 15.539C18.1001 15.4463 18.3972 15.4222 18.689 15.4667L22.8667 16.3557C23.1927 16.4446 23.463 16.6171 23.6777 16.8733C23.8926 17.1296 24 17.4162 24 17.7333V22.5333C24 22.9524 23.8603 23.3017 23.581 23.581C23.3017 23.8603 22.9524 24 22.5333 24ZM3.76667 8.26667L6.3 5.711L5.6 2.22233H2.23333C2.3 3.14811 2.45189 4.10367 2.689 5.089C2.92589 6.07411 3.28511 7.13333 3.76667 8.26667ZM15.9443 20.311C16.8408 20.7186 17.7946 21.0482 18.8057 21.3C19.8168 21.5518 20.8074 21.7037 21.7777 21.7557V18.4L18.4443 17.7223L15.9443 20.311Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#3E3B39",
    },
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
